import i18n from '@/locales'
export default [
  {
    type: 'input',
    placeholder: i18n.t('Fota.taskName'),
    filed: 'name',
    default: ''
  },
  {
    type: 'input',
    placeholder: i18n.t('Fota.initVersion'),
    filed: 'version',
    default: ''
  },
  // {
  //   type: 'select',
  //   placeholder: '升级方式',
  //   filed: 'upgradeType',
  //   default: '',
  //   options: [
  //     {
  //       code: 'FORCE',
  //       name: '强制升级'
  //     },
  //     {
  //       code: 'NOT_FORCE',
  //       name: '自主升级'
  //     }
  //   ]
  // },
  {
    type: 'select',
    placeholder: i18n.t('Fota.targetType'),
    filed: 'targetType',
    default: '',
    options: [
      {
        code: 'VERSION',
        name: i18n.t('Fota.targetVERSION')
      },
      {
        code: 'DEVICE',
        name: i18n.t('Fota.targetDEVICE')
      }
    ]
  },
  {
    type: 'datepicker',
    placeholder: '',
    default: [],
    filed: 'daterange',
    params: {
      start: 'startTime',
      end: 'endTime'
    }
  }
]
